/// <reference path="../include.ts" />

namespace project_guide {

	import Lang = project_common.Lang;
	import Region = project_common.Region;
	import Area = project_common.Area;
	import Zone = project_common.Zone;
	import Species = project_common.Species;
	import BannerLink = project_common.BannerLink;
	import Dom = alm.util.Dom;
	import DataParser = project_common.DataParser;
	import DomUtil = project_common.DomUtil;

	export class BindingUtil {

		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public static setSpeciesNameTexts(nameContainer:JQuery, species:Species, lang:Lang):void {
			const nameFieldValue = SpeciesUtil.getNameFieldValue(species, lang);
			BindingUtil.setSpeciesNameText(nameContainer.find('.main'), nameFieldValue.main, nameFieldValue.isMainScientific, true);
			BindingUtil.setSpeciesNameText(nameContainer.find('.sub1'), nameFieldValue.sub1, nameFieldValue.isSub1Scientific, false);
			BindingUtil.setSpeciesNameText(nameContainer.find('.sub2'), nameFieldValue.sub2, nameFieldValue.isSub2Scientific, false);
		}

		public static setSpeciesNameText(textField:JQuery, value:string, isScientific:boolean, asHtml:boolean):void {
			if (value) {
				textField.css('display', 'block');
				if (asHtml) {
					DomUtil.setHtml(textField, value);
				} else {
					textField.text(value);
				}
			} else {
				textField.css('display', 'none');
				textField.text('');
			}

			if (isScientific) {
				textField.addClass('scientific');
			} else {
				textField.removeClass('scientific');
			}
		}





		public static setZoneHeaderText(header:JQuery, region:Region, area:Area, zone:Zone, lang:Lang):void {
			const regionName = DataParser.localize(region.name, lang);
			const areaName = DataParser.localize(area.name, lang);
			const zoneName = DataParser.localize(zone.name, lang);

			// breadcrumb
			{
				const field = header.find('.zone-breadcrumb');
				if (regionName || areaName) {
					DomUtil.setHtml(field, [regionName, areaName].join(' '));
				} else {
					field.css('display', 'none');
				}
			}

			// zone
			{
				const field = header.find('.zone-name');
				DomUtil.setHtml(field, zoneName);
			}
		}





		public static createBannerLink(data:BannerLink, lang:Lang):JQuery {
			const view = jQuery(Dom.instantiate('banner-item-link-template'));

			const button = view.find('.button');

			const a = button.find('a');
			a.attr('href', data.url);

			const image = button.find('img');
			image.attr('src', '../static/img/app-download-button-' + data.type + '.png');

			return view;
		}





		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
		}
	}
}
